export const USER_PROFILE_FIELDS = `
	id
	firstName
	lastName
	email
	country	
  aboutMe
  dashboardState
  aiCategories
	arxiv
	github
	googleScholar
	adminOf @include(if: $isAuth) {
	  id
	}
	jobTitle
	linkedin
	twitter
	website
	profilePic
	createdAt
	memberOf { 
      id
      inTrial
      customPrice
      customMaxSeats
      startsAt
      ${process.env.REACT_APP_ENV === "dev" ? "expiresAt" : ""}
      members {
        id
        firstName
        lastName
        profilePic
        createdAt
        email
        jobTitle
        aboutMe
      }
      admins {
        id
        firstName
        lastName
        profilePic
        createdAt
        email
        jobTitle
        aboutMe
      }
      type {
        id
        name
        price
        maxSeats
        minSubscriptionMonths
        createdAt
      }
  }
	organization @include(if: $isAuth) {
		id
		name
    createdAt
    logo
    employees {
      id
      email
      firstName
      lastName
      createdAt
      profilePic
      adminOf {
        id
      }
    }
    hasSubscription {
      id
      inTrial
      customPrice
      customMaxSeats
      startsAt
      ${process.env.REACT_APP_ENV === "dev" ? "expiresAt" : ""}
      members {
        id
        firstName
        lastName
        profilePic
        createdAt
        email
	      jobTitle
	      aboutMe
      }
      admins {
        id
        firstName
        lastName
        profilePic
        createdAt
        email
	      jobTitle
	      aboutMe
      }
      type {
        id
        name
        price
        maxSeats
        minSubscriptionMonths
        createdAt
      }
    }
  }
`;
